import PropTypes from "prop-types";
import queryString from "query-string";
import Link from "react-router-dom/Link";
import React from "react";
import Table from "reactstrap/lib/Table";

import SortHeaderWithSeparateKeysComponent from "components/common/SortHeader/SeparateKeys";

const FLSAReportTableComponent = (props, context) => {
  const {
    router: {
      route: {
        match: {},
      },
    },
  } = context;
  const {
    data,
    location: { query },
    pageSize,
  } = props;
  const { page = 1 } = query;

  return (
    <div className="ml-3 mr-4">
      <Table
        hover
        responsive
        size="sm"
        className="table-overtime-report align-table right-align-table right-align-col align-firstcol"
      >
        <thead className="Header-col">
          <tr>
            <SortHeaderWithSeparateKeysComponent field="first_name">
              First Name
            </SortHeaderWithSeparateKeysComponent>

            <SortHeaderWithSeparateKeysComponent field="last_name">
              Last Name
            </SortHeaderWithSeparateKeysComponent>

            <SortHeaderWithSeparateKeysComponent field="employee_id">
              Employee ID
            </SortHeaderWithSeparateKeysComponent>

            <SortHeaderWithSeparateKeysComponent field="week_start_date">
              Week Start Date
            </SortHeaderWithSeparateKeysComponent>

            <SortHeaderWithSeparateKeysComponent field="week_end_date">
              Week End Date
            </SortHeaderWithSeparateKeysComponent>

            <SortHeaderWithSeparateKeysComponent field="qualified_ot">
              Qualified OT
            </SortHeaderWithSeparateKeysComponent>

            <SortHeaderWithSeparateKeysComponent field="qualified_dt">
              Qualified DT
            </SortHeaderWithSeparateKeysComponent>
          </tr>
        </thead>

        <tbody>
          {data
            .filter(
              (item, index) =>
                index < page * pageSize && index >= (page - 1) * pageSize,
            )
            .map((item) => (
              <tr key={item.index}>
                <td className="pl-3">{item.first_name}</td>
                <td>{item.last_name}</td>
                <td>{item.employee_id}</td>
                <td>{item.week_start_date}</td>
                <td>{item.week_end_date}</td>
                <td className="text-right">{item.qualified_ot}</td>
                <td className="text-right pr-3">{item.qualified_dt}</td>
              </tr>
            ))}

          {!data.length && Object.keys(query).length > 0 && (
            <tr>
              <td colSpan="7" className="text-center">
                No Records Found
              </td>
            </tr>
          )}

          {!data.length && Object.keys(query).length === 0 && (
            <tr>
              <td colSpan="7" className="text-center">
                Search above for results
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

FLSAReportTableComponent.propTypes = {
  data: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
};

FLSAReportTableComponent.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default FLSAReportTableComponent;
